import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Style from "./../../../assets/scss/custom.module.scss";
import { promoPageAction } from "../../../locales/en";

const AccessPageAction = ({ subheading, allpromocodes, createpromocodes }) => {
  return (
    <div className="row mb-2 mx-0">
      <div className="col-12 sales-page-title-wrap sub-heading-blog-wrap pb-2">
        <div className="row box-heading">
          <div className="col-md-4 d-flex flex-wrap align-items-center">
            <h2>{subheading}</h2>
          </div>
          <div className="col-md-8">
            <ul
              className={`${Style.searchOptionWrap} d-flex flex-wrap align-items-center justify-content-end`}
            >
              <li className="my-1">
                <Link to={allpromocodes} className="btn btn-blue">
                  {promoPageAction.allPromoBtn}
                </Link>
              </li>
              <li className="my-1">
                <Link to={createpromocodes} className="btn btn-primary">
                  {promoPageAction.createPromoBtn}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
AccessPageAction.propTypes = {
  subheading: PropTypes.string.isRequired,
  allpromocodes: PropTypes.string.isRequired,
  createpromocodes: PropTypes.string.isRequired
};

export default AccessPageAction;
